import React, { useMemo } from 'react';
import { StyleSheet, Pressable, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTableContext } from '@/context/TableContext';

const createStyles = (colors, isSlim) => StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: isSlim ? 4 : 8,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.border_color_secondary,
    height: isSlim ? 32 : 44,
  },
  column: {
    justifyContent: 'center',
  },
});

const BasicTableRow = ({
  data,
  renderColumn,
  onPress,
  onHoverIn,
  onHoverOut,
  isHovered,
  isSlim = false,
  style,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors, isSlim), [colors, isSlim]);
  const { columns } = useTableContext();

  const rowContent = (
    <>
      {columns.map((column, index) => (
        <View
          key={`column-${index}`}
          style={[
            styles.column,
            { width: column.width },
            column.cellStyle,
          ]}
        >
          {renderColumn(column, data)}
        </View>
      ))}
    </>
  );

  if (onPress) {
    return (
      <Pressable 
        style={[
          styles.row,
          isHovered && { backgroundColor: colors.solid_color_tertiary },
          style,
        ]}
        onPress={onPress}
        onHoverIn={onHoverIn}
        onHoverOut={onHoverOut}
      >
        {rowContent}
      </Pressable>
    );
  }

  return (
    <View style={[styles.row, style]}>
      {rowContent}
    </View>
  );
};

export default BasicTableRow; 